import React from "react";
import { useTranslation } from "react-i18next";
import { Props, AvailableLanguages, Config } from "./types";

const availableLanguages: AvailableLanguages[] = ["fr", "en"];

function useLanguage(): Config {
  const { i18n } = useTranslation();

  return {
    currentLanguage:
      availableLanguages.find((lang) =>
        new RegExp(lang, "i").test(i18n.language),
      ) || "fr",
    availableLanguages,
  };
}

function Language({ children }: Props) {
  const conf = useLanguage();

  return <React.Fragment>{children(conf)}</React.Fragment>;
}

export type { Config, AvailableLanguages };

export { useLanguage, Language, availableLanguages };
